import { render, staticRenderFns } from "./PessoaConexaoDetalhes.vue?vue&type=template&id=4540f5ab"
import script from "./PessoaConexaoDetalhes.vue?vue&type=script&lang=js"
export * from "./PessoaConexaoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports